<template>
  <div class="flex flex-col gap-3">
    <PaginatedList :load="load" :query-key="queryKey" :empty-text="t('noTransferFound')">
      <template #entry="{ entry }">
        <TransferListItem :transfer="entry" />
      </template>
    </PaginatedList>
  </div>
</template>

<script lang="ts" setup>
import PaginatedList from '@/components/PaginatedList.vue';
import TransferListItem from './TransferListItem.vue';
import { allocationsService } from '@/api/allocations.service';
import { ALLOCATIONS_QUERY_KEY } from '@/queries/use-allocations';
import type { AllocationsControllerFindAllData } from '@carvia/ros-client-types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  query: NonNullable<AllocationsControllerFindAllData['query']>;
}>();

const { t } = useI18n();
const queryKey = computed(() => [ALLOCATIONS_QUERY_KEY, props.query]);
const load = (page: number) => allocationsService.getAllWithQuery({ ...props.query, page });
</script>

<i18n lang="json">
{
  "en": {
    "noTransferFound": "No transfers found"
  },
  "de": {
    "noTransferFound": "Es wurden keine Transfers gefunden"
  },
  "es": {
    "noTransferFound": "No se encontraron traslados"
  }
}
</i18n>
